module.exports = __webpack_public_path__ + "static/media/taco-emoji.1cbf0280.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/taco-emoji.png
// module id = 152
// module chunks = 0